import { CircleIcon, Icon } from '@aptuno/aptuno-ui';
import { ListingShared } from '@contexts/Estate/ListingDetails/events/listing-shared.event';
import { useAnalyticsTracker } from '@services/analytics';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { SocialButton } from '../Footer/Footer.styled';
import { LinkButton, SocialWrapper } from './SocialShare.styled';

const enum SocialNetworks {
  FACEBBOK = 'facebook',
  LINKEDIN = 'linkedIn',
  TWITTER = 'twitter',
  CLIPBOARD = 'clipboard',
}

const SocialShare = ({ estateLegalId, withText = true }: { estateLegalId: number; withText?: boolean }) => {
  const [copied, setCopied] = React.useState(false);
  const currentUrl = typeof window !== 'undefined' ? window.location.href : process.env.NEXT_PUBLIC_URL_APTUNO || '';
  const eventTracker = useAnalyticsTracker();

  const handleClickOnShareBtn = (socialNetwork: SocialNetworks) => {
    eventTracker.trackEvent(new ListingShared(`${estateLegalId}`, socialNetwork));
  };

  return (
    <SocialWrapper>
      <FacebookShareButton url={currentUrl} onClick={() => handleClickOnShareBtn(SocialNetworks.FACEBBOK)}>
        <SocialButton>
          <Icon icon="facebook"></Icon>
        </SocialButton>
        {withText && <p>Facebook</p>}
      </FacebookShareButton>
      <LinkedinShareButton url={currentUrl} onClick={() => handleClickOnShareBtn(SocialNetworks.LINKEDIN)}>
        <SocialButton>
          <Icon icon="linkedin-square"></Icon>
        </SocialButton>
        {withText && <p>Linkedin</p>}
      </LinkedinShareButton>
      <TwitterShareButton url={currentUrl} onClick={() => handleClickOnShareBtn(SocialNetworks.TWITTER)}>
        <SocialButton>
          <Icon icon="twitter"></Icon>
        </SocialButton>
        {withText && <p>Twitter</p>}
      </TwitterShareButton>
      <CopyToClipboard
        text={currentUrl}
        onCopy={() => setCopied(true)}
        onClick={() => handleClickOnShareBtn(SocialNetworks.CLIPBOARD)}
      >
        <LinkButton isSelected={copied}>
          <SocialButton>
            <CircleIcon refIcon={'link'} appearance={copied ? 'primaryBlue' : 'secondary'} />
          </SocialButton>
          {withText && <p>{copied ? 'Link Copiado' : 'Copiar Link'}</p>}
        </LinkButton>
      </CopyToClipboard>
    </SocialWrapper>
  );
};

export default SocialShare;
